import React, { useContext } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Button, Spinner, Typography } from "@material-tailwind/react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { NewContext } from '../../Context/NewContext';
import { update_music, delete_music, delete_all_music, delete_sticker, delete_all_sticker, update_sticker, delete_sticker_Tags, delete_all_sticker_Tags, update_sticker_Tags, delete_feedback, update_feedback, update_Rating, delete_all_Rating, delete_Rating, delete_FeedbackCategory, delete_all_FeedbackCategory, update_FeedbackCategory, delete_all_Feedback_Sub_Category, update_Feedback_Sub_Category, delete_Feedback_Sub_Category, update__Blog, update__Blog_categories, deleteAll__Blog_categories, deleteAll__Reply, deleteAll__Blog, delete__Blog_categories, delete__Blog, delete__Reply, delete_subscription, delete_all_subscription, delete_faq, update_faq, update_Feedbackcategory_Setting, delete_asset, delete_bank_regex, delete_sms_regex, update_bank_regex, delete_wallpaper, delete_all_wallpaper, update_wallpaper, update_themes, delete_all_themes, delete_themes, delete_font, delete_all_font, update_font, delete_all_bubble, delete_bubble, update_bubble } from '../../Controller/actions';
import { DialogActions } from '@mui/material';
import { deleteAllFeedback } from '../../Controller/api';

export const ConfirmationModal = () => {
    const navigate = useNavigate();
    const { handleChildClose, currentHomeModalKey, setAddEditDeleteTag, setOpen, isLoading, setIsLoading, confirmationModalShow, setConfirmationModalShow, setDeleteUpdateTag, setCheckedValues, deleteUpdateItem, setDeleteUpdateItem, deleteUpdateYes, setDeleteUpdateYes } = useContext(NewContext);

    const handleConfirmationClose = () => {
        setConfirmationModalShow(!confirmationModalShow);
        setDeleteUpdateTag("");
        setDeleteUpdateItem({});
        setCheckedValues([]);
        if (!currentHomeModalKey) {
            setOpen(false);
        }
    };
    const handleLogout = () => {
        localStorage.clear();
        toast.success("Logout successfully.");
        navigate('/signin');
    }
    const handleYes = async () => {
        let deleteUpdateByTag;
        setIsLoading(true);
        setDeleteUpdateTag(deleteUpdateYes + deleteUpdateItem.id);

        if (deleteUpdateYes === "logout") { handleLogout() }

        // SINGLE DATA DELETE
        if (deleteUpdateYes === "delete-sticker") { deleteUpdateByTag = await delete_sticker(deleteUpdateItem.id) }
        if (deleteUpdateYes === "delete-music") { deleteUpdateByTag = await delete_music(deleteUpdateItem.id) }
        if (deleteUpdateYes === "delete-sticker-tag") { deleteUpdateByTag = await delete_sticker_Tags(deleteUpdateItem.id) }
        if (deleteUpdateYes === "delete-feedback") { deleteUpdateByTag = await delete_feedback(deleteUpdateItem.id) }
        if (deleteUpdateYes === "delete-rating") { deleteUpdateByTag = await delete_Rating(deleteUpdateItem.id) }
        if (deleteUpdateYes === "delete-feedback-category") { deleteUpdateByTag = await delete_FeedbackCategory(deleteUpdateItem.id) }
        if (deleteUpdateYes === "delete-feedback-sub-category") { deleteUpdateByTag = await delete_Feedback_Sub_Category(deleteUpdateItem.id) }
        if (deleteUpdateYes === "delete-blog-categories") { deleteUpdateByTag = await delete__Blog_categories(deleteUpdateItem.id) }
        if (deleteUpdateYes === "delete-blogs") { deleteUpdateByTag = await delete__Blog(deleteUpdateItem.id) }
        if (deleteUpdateYes === "delete-reply") { deleteUpdateByTag = await delete__Reply(deleteUpdateItem.id) }
        if (deleteUpdateYes === "delete-subscription") { deleteUpdateByTag = await delete_subscription(deleteUpdateItem.id) }
        if (deleteUpdateYes === "delete-bank-regex") { deleteUpdateByTag = await delete_bank_regex(deleteUpdateItem.id) }
        if (deleteUpdateYes === "delete-sms-regex") { deleteUpdateByTag = await delete_sms_regex(deleteUpdateItem.id) }

        if (deleteUpdateYes === "delete-theme-wallpaper") { deleteUpdateByTag = await delete_wallpaper(deleteUpdateItem.id) }
        if (deleteUpdateYes === "delete-theme") { deleteUpdateByTag = await delete_themes(deleteUpdateItem.id) }
        if (deleteUpdateYes === "delete-theme-font") { deleteUpdateByTag = await delete_font(deleteUpdateItem.id) }
        if (deleteUpdateYes === "delete-theme-bubble") { deleteUpdateByTag = await delete_bubble(deleteUpdateItem.id) }


        // ALL DATA DELETE
        if (deleteUpdateYes === "all-delete-sticker") { deleteUpdateByTag = await delete_all_sticker(deleteUpdateItem) }
        if (deleteUpdateYes === "all-delete-music") { deleteUpdateByTag = await delete_all_music(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "all-delete-sticker-tag") { deleteUpdateByTag = await delete_all_sticker_Tags(deleteUpdateItem) }
        if (deleteUpdateYes === "all-delete-feedback") { deleteUpdateByTag = await deleteAllFeedback(deleteUpdateItem) }
        if (deleteUpdateYes === "all-delete-rating") { deleteUpdateByTag = await delete_all_Rating(deleteUpdateItem) }
        if (deleteUpdateYes === "all-delete-feedback-category") { deleteUpdateByTag = await delete_all_FeedbackCategory(deleteUpdateItem) }
        if (deleteUpdateYes === "all-delete-feedback-sub-category") { deleteUpdateByTag = await delete_all_Feedback_Sub_Category(deleteUpdateItem) }
        if (deleteUpdateYes === "all-delete-blog-categories") { deleteUpdateByTag = await deleteAll__Blog_categories(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "all-delete-blogs") { deleteUpdateByTag = await deleteAll__Blog(deleteUpdateItem) }
        if (deleteUpdateYes === "all-delete-reply") { deleteUpdateByTag = await deleteAll__Reply(deleteUpdateItem) }

        if (deleteUpdateYes === "all-delete-wallpaper") { deleteUpdateByTag = await delete_all_wallpaper(deleteUpdateItem) }
        if (deleteUpdateYes === "all-delete-themes") { deleteUpdateByTag = await delete_all_themes(deleteUpdateItem) }
        if (deleteUpdateYes === "all-delete-font") { deleteUpdateByTag = await delete_all_font(deleteUpdateItem) }
        if (deleteUpdateYes === "all-delete-bubble") { deleteUpdateByTag = await delete_all_bubble(deleteUpdateItem) }


        // SINGLE DATA UPDATE
        if (deleteUpdateYes === "update-sticker") { deleteUpdateByTag = await update_sticker(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "update-music") { deleteUpdateByTag = await update_music(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "update-sticker-tag") { deleteUpdateByTag = await update_sticker_Tags(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "update-feedback") { deleteUpdateByTag = await update_feedback(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "update-rating") { deleteUpdateByTag = await update_Rating(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "update-feedback-category") { deleteUpdateByTag = await update_FeedbackCategory(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "update-feedback-sub-category") { deleteUpdateByTag = await update_Feedback_Sub_Category(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "update-blog-categories") { deleteUpdateByTag = await update__Blog_categories(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "update-blogs") { deleteUpdateByTag = await update__Blog(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "update-update-blog-categoriesfeedback-category-setting") { deleteUpdateByTag = await update_Feedbackcategory_Setting(deleteUpdateItem) }
        // if (deleteUpdateYes === "update-bank-regex") { deleteUpdateByTag = await update_bank_regex(deleteUpdateItem) }
        if (deleteUpdateYes === "update-bank-regex") { deleteUpdateByTag = await update_bank_regex(deleteUpdateItem, deleteUpdateItem.id) }

        if (deleteUpdateYes === "update-theme-wallpaper") { deleteUpdateByTag = await update_wallpaper(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "update-theme") { deleteUpdateByTag = await update_themes(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "update-theme-font") { deleteUpdateByTag = await update_font(deleteUpdateItem, deleteUpdateItem.id) }
        if (deleteUpdateYes === "update-theme-bubble") { deleteUpdateByTag = await update_bubble(deleteUpdateItem, deleteUpdateItem.id) }



        // FAQ
        if (deleteUpdateYes === "delete-FAQ") {
            deleteUpdateByTag = await delete_faq(deleteUpdateItem.id);
        }

        if (deleteUpdateYes === "update-FAQ") {
            deleteUpdateByTag = await update_faq(
                deleteUpdateItem,
                deleteUpdateItem.id
            );
        }

        // asset
        if (deleteUpdateYes === "delete-asset") {
            deleteUpdateByTag = await delete_asset(deleteUpdateItem.id);
        }


        if (deleteUpdateByTag) {
            const { message, status } = deleteUpdateByTag;
            if (status) {
                toast.success(message);
                setDeleteUpdateYes("");
                setDeleteUpdateTag("");
                setCheckedValues([]);
                setIsLoading(false);
            } else {
                toast.error(message);
            };
        }
        if (currentHomeModalKey) {
            handleChildClose();
            setAddEditDeleteTag(`update`);
        } else {
            setAddEditDeleteTag(`add`);
        }
        handleConfirmationClose();

    }

    return (
        <>
            <Dialog className='p-[30px]'
                open={confirmationModalShow}
                handler={handleConfirmationClose}
                // onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "466px",
                            padding: "30px",
                            borderRadius: "12px" // Set your width here
                        },
                    },
                }}
            >
                <DialogTitle id="responsive-dialog-title" className='flex justify-center p-0 text-[#1E1627]'>
                    {/* <Typography variant="h5" >Are You Sure?</Typography> */}
                    <strong>Are You Sure?</strong>
                </DialogTitle>
                <DialogContent>
                    <Typography className="text-center font-normal leading-3 text-[17px] text-[#1E1627]">
                        Do you really want to {deleteUpdateYes?.split('-').includes('update') ? `update` : `delete`} these records ?
                        <br />
                        {deleteUpdateYes?.split('-').includes('update') ? `` : `This process cannot be undone`}
                    </Typography>
                </DialogContent>
                <DialogActions className="flex gap-2.5 !justify-center p-0">
                    <Button variant="outlined" color="blue-gray" className='capitalize shadow-none hover:shadow-none border-[#75869F] font-medium text-base leading-none' onClick={handleConfirmationClose}>Cancel</Button>
                    <Button
                        disabled={isLoading}
                        onClick={handleYes}
                        className={`${deleteUpdateYes?.split('-').includes(`delete`) ? `bg-[#F22F42]` : `bg-[#0047FF]`} flex items-center capitalize shadow-none hover:shadow-none font-medium text-base leading-none !ml-0`}
                    >
                        {isLoading && <Spinner className="h-4 w-4" />}
                        <span className={isLoading ? 'ml-4' : ''}>{deleteUpdateYes?.split('-').includes(`delete`) ? `Delete` : `Yes`}</span>
                    </Button>
                </DialogActions>

            </Dialog>
        </>
    );
}

export default ConfirmationModal;